import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  currentUser: {},
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoggedInUser: (state, action) => {
      state.currentUser = action.payload
    }
  },
})

export const { setLoggedInUser } = authSlice.actions
export default authSlice.reducer
